import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { addUpFilters } from "./actions";
import { AddUpFiltersCommand } from "./request";

export class AddUpFiltersHandler extends StoreBaseHandler {
  async handle(request: AddUpFiltersCommand) {
    try {
      //TODO ensure are valid filters
      this.store.dispatch(addUpFilters(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
